import actionTypes from "../../action-types";

export const ToggleDarkmode = () => {
  return { type: actionTypes.TOGGLE_DARK_MODE };
};
export const ToggleMenuSidebar = () => {
  return { type: actionTypes.TOGGLE_MENU_SIDEBAR };
};
